import { render, staticRenderFns } from "./div-html.vue?vue&type=template&id=84600f12&scoped=true"
import script from "./div-html.vue?vue&type=script&lang=js"
export * from "./div-html.vue?vue&type=script&lang=js"
import style0 from "./div-html.vue?vue&type=style&index=0&id=84600f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84600f12",
  null
  
)

export default component.exports